// extracted by mini-css-extract-plugin
export default {"grid_container":"Layout_grid_container__LKumE","grid_main":"Layout_grid_main__AUPiR"};